module.exports = __webpack_public_path__ + "img/jiqiren1.18d39071.jpg";